<template>
  <div>
    <entrepreneur-edit @onEntrepreneurSubmit="createEntrepeneur" :submit-btn-label="$t('button-create-entrepeneur')" :name="name" :month="month" :year="year" :gender="gender" />
  </div>
</template>

<script>
import EntrepreneurEdit from '@/components/form/entrepreneur-edit'

import EntrepreneurService from '@/services/entrepreneur'
import NotificationService from '@/services/notification'

import i18n from '@/helpers/i18n'

export default {
  props: {
    businessId: {
      type: String,
      required: false
    }
  },
  components: { EntrepreneurEdit },
  data() {
    return {
      name: '',
      month: '',
      year: '',
      thisYear: new Date().getFullYear(),
      gender: 0
    }
  },
  methods: {
    createEntrepeneur: async function(entrepreneurInfo) {
      let date = null
      var entrepreneur = null

      if (entrepreneurInfo.year !== '' && entrepreneurInfo.month !== '') {
        date = new Date(entrepreneurInfo.year, entrepreneurInfo.month, 1)
      }

      if (this.businessId) {
        entrepreneur = await EntrepreneurService.createEntrepreneurFromBusiness(this.businessId, entrepreneurInfo.name, date, entrepreneurInfo.gender)
      } else {
        entrepreneur = await EntrepreneurService.createEntrepreneur(entrepreneurInfo.name, date, entrepreneurInfo.gender)
      }

      NotificationService.showSuccess(i18n.t('entrepreneur-create-success-notification'))
      this.$emit('onEntrepreneurAdded', entrepreneur)
    }
  }
}
</script>
